import React from 'react'
import {BoxSelection, BoxSelectionBoxSize} from 'wix-ui-tpa/cssVars'
import {isEqual} from 'date-fns'
import {Status, TimeSlot} from '@wix/ambassador-table-reservations-v1-time-slot/types'

import {getShortTime} from '../../utils/dateString'
import {LayoutSize} from '../LayoutSizeProvider/types'

import {tagsListDataHooks} from './constants'
import {classes, st} from './TagsList.st.css'

export interface TagsListProps {
  label: string
  timeSlots: TimeSlot[]
  selectedTimeSlot?: Date
  regionalSettings?: string
  onSelectTimeSlot(item: TimeSlot): void
  extended?: boolean
  layoutSize: LayoutSize
  boxSelectionClassName?: string
  timeClassName?: string
  nonWorkingHoursTimeSlotClassName?: string
}

export const TagsList: React.FC<TagsListProps> = ({
  layoutSize,
  label,
  timeSlots,
  selectedTimeSlot,
  onSelectTimeSlot,
  regionalSettings,
  extended = false,
  boxSelectionClassName,
  timeClassName,
  nonWorkingHoursTimeSlotClassName,
}) => {
  if (!timeSlots?.length) {
    return null
  }

  const selectedTimeSlotIndex = selectedTimeSlot
    ? timeSlots.findIndex((item) => isEqual(selectedTimeSlot, item.startDate!))
    : -1

  return (
    <BoxSelection
      size={BoxSelectionBoxSize.small}
      name="time-slots"
      label={label}
      className={st(
        '',
        {[layoutSize]: true, extended},
        classes.boxSelection,
        boxSelectionClassName,
      )}
      onChange={({id}) => {
        const timeSlot = timeSlots[Number(id)]
        const disabled = timeSlot.status !== Status.AVAILABLE

        if (!disabled) {
          onSelectTimeSlot(timeSlot)
        }
      }}
    >
      {timeSlots.map((timeSlot, index) => {
        const title = getShortTime(new Date(timeSlot.startDate!), regionalSettings)
        const disabled = timeSlot.status !== Status.AVAILABLE
        const selected = selectedTimeSlotIndex === index

        if (timeSlot.status === Status.NON_WORKING_HOURS) {
          return (
            <div
              key={index}
              className={st(classes.nonWorkingHoursTimeSlot, nonWorkingHoursTimeSlotClassName)}
            />
          )
        }

        return (
          <BoxSelection.Option
            key={index}
            id={index.toString()}
            checked={selected}
            disabled={disabled}
            unavailable={disabled}
            aria-disabled={disabled}
            aria-label={title}
            data-hook={tagsListDataHooks.timeSlot({index, available: !disabled})}
          >
            <time className={st('', {selected}, classes.time, timeClassName)}>{title}</time>
          </BoxSelection.Option>
        )
      })}
    </BoxSelection>
  )
}
